// 供应商列表
const ListData = {
  Id: 0,
  boxLines: [
    {
      rowList: [{ title: "供应商名称: ", banding: "Name", value: "", className: 'c-three-color' }]
    },
    {
      rowList: [
        {
          title: "地址: ",
          banding: "Address",
          value: ""
        }
      ]
    }
  ]
};
// 供应商账户
const AccountData = {
  Id: 0,
  boxLines: [
    {
      rowList: [
        { title: "供应商名称:", banding: "SupplierName", value: "" , className: 'c-three-color'}
      ]
    },
    {
      rowList: [
        {
          title: "区域：",
          banding: "AreaType",
          value: "",
          dataType: "Type",
          dataMap: {  1: "香港境内", 2: "香港境外" }
        },
        { title: "币别: ", banding: "CurrencyType", value: "" },
      ]
    },
    {
      rowList: [

        { title: "账户名称: ", banding: "AccountName", value: "" }
      ]
    },
    {
      rowList: [
        { title: "银行名称: ", banding: "BankName", value: "" }
      ]
    },

    {
      rowList: [
        {
          title: "银行账号: ",
          banding: "Account",
          value: " "
        }
      ]
    },
    {
      rowList: [{ title: "SwiftCode: ", banding: "SwiftCode", value: "lkdsjgkhgjsdgh" }]
    },
    {
      rowList: [
        {
          title: "地址: ",
          banding: "Address",
          value: ""
        }
      ]
    }
  ]
};

// 供应商地址
const AddressData = {
  Id: 0,
  boxLines: [
    {
      rowList: [{ title: "供应商名称: ", banding: "SupplierName", value: "", className: 'c-three-color' }]
    },
    {
      rowList: [
        { title: "提货联系人: ", banding: "ContactName", value: "" },
        { title: "联系电话: ", banding: "Mobile", value: "" }
      ]
    },
    {
      rowList: [
        {
          title: "地址: ",
          banding: "Address",
          value: ""
        }
      ]
    }
  ]
};

export { ListData, AccountData, AddressData };
